import { render, staticRenderFns } from "./profileTab.vue?vue&type=template&id=89621e6e&scoped=true&"
import script from "./profileTab.vue?vue&type=script&lang=js&"
export * from "./profileTab.vue?vue&type=script&lang=js&"
import style0 from "./profileTab.vue?vue&type=style&index=0&id=89621e6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89621e6e",
  null
  
)

export default component.exports